<template>
<section>

	<div class="count-wrap bluestyle">
		<div class="count-inner">
			<div class="count-text">碳水化合物</div>
			<countTo
				class="count-num" 
				:separator='theseparator' 
				:startVal='startVal' 
				:endVal='endVal' 
				:duration='2000'
			>
			</countTo>
			<div class="count-text">克</div>
		</div>
	</div>
	<div class="result-wrap text-center">
		<div class="result-thumb">
			<img :src="cover">
		</div>
		<div class="result-text">需补打胰岛素</div>
		<div class="result-time wcar">
			<div class="times" v-if="unit"><span>{{unit}}</span>单位</div>
		</div>
	</div>

	<div class="calculate-link" @click="gohome()">返回首页</div>

</section>
</template>

<script>
  import countTo from 'vue-count-to';
  export default {
    components: { countTo },
    data () {
      return {
        startVal: 0,
        endVal: 22.2,
        theseparator:'',
        cover:'/static/zhushe.png',
        unit:0
      }
    },
    head: {
		title: function () {
			return {
				inner: '补打胰岛素',
				separator: ' ', 
        		complement: ' '
			}
		}
	},
    created(){
    	this.endVal = parseInt(this.$route.query.carbo_total)
    	this.unit   = parseInt(this.endVal / 15)
    },
    methods:{
    	gohome(){
    		this.$router.replace({ path: '/carboindex'});
    	}
    }
  }
</script>
<style scoped>
.count-wrap{
	margin-top:.6rem;
}
.result-wrap .result-time{
	padding:0 .5rem;
	min-width: 4rem;
}
.result-wrap .result-thumb img{
	height:2.85rem;
}
.result-wrap .result-text{
	margin-top:.25rem;
}
</style>


// WEBPACK FOOTER //
// carboresult.vue?6db9f01f